import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { CircularProgress } from "@mui/material";
import adminApi, { saveSession } from "./api";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.error("Please enter your email and password");
      return;
    }

    setLoading(true);
    try {
      const res = await adminApi.post("/admin/login", { email, password });
      saveSession(res.data.token, res.data.admin);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full min-h-dvh bg-[#1b1d1f] flex items-center justify-center p-4">
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-[420px] bg-gradient-mn rounded-xl p-6 md:p-8 flex flex-col gap-5 shadow-2xl"
      >
        <div className="text-center">
          <h1 className="text-white times-new-roman text-[28px] font-bold">
            Sean McFirnn Admin
          </h1>
          <p className="text-[#D2C7D2] text-[13px] mt-1">
            Sign in to moderate reviews
          </p>
        </div>

        <div className="flex flex-col gap-1">
          <label className="text-white text-[13px]">Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="admin@seanmcfirnn.com"
            autoComplete="username"
            className="rounded-md px-3 py-2 text-[15px] bg-[#ffffff2a] text-white placeholder:text-[#CECECE] w-full outline-none focus:ring-1 focus:ring-white"
          />
        </div>

        <div className="flex flex-col gap-1">
          <label className="text-white text-[13px]">Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            autoComplete="current-password"
            className="rounded-md px-3 py-2 text-[15px] bg-[#ffffff2a] text-white placeholder:text-[#CECECE] w-full outline-none focus:ring-1 focus:ring-white"
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          className="mt-2 w-full rounded-md bg-[#2aa9a0] hover:bg-[#22908a] disabled:opacity-60 text-white text-[15px] font-bold py-2.5 flex items-center justify-center gap-2 transition-colors"
        >
          {loading && <CircularProgress size={16} sx={{ color: "#fff" }} />}
          {loading ? "Signing in..." : "Sign in"}
        </button>
      </form>
    </div>
  );
};

export default AdminLogin;
